import React from 'react';
import { Button, Modal } from 'antd';
import { CheckOutlined } from '@ant-design/icons';
import useBreakpoint from '../../../../hooks/useBreakpoint';

const BTN_BASE =
  '!h-12 !rounded-xl !text-[15px] !font-semibold !shadow-none !transition-colors';

const BTN_OUTLINE = `${BTN_BASE} !border-gray-200 !bg-white !text-gray-700 hover:!border-gray-300 hover:!bg-gray-50 hover:!text-gray-900`;

export default function PlaceOrderSuccessModal({
  open,
  investorName,
  onCreateNewOrder,
  onGoToTransactions,
}) {
  const isAboveSm = useBreakpoint('sm');

  return (
    <Modal
      open={open}
      footer={null}
      closable={false}
      maskClosable={false}
      centered={isAboveSm}
      width={440}
      destroyOnClose
      styles={{ body: { padding: '28px 24px 24px' } }}
    >
      <div className="flex flex-col items-center text-center">
        <span
          className="flex h-14 w-14 items-center justify-center rounded-full bg-primary text-white shadow-[0_4px_14px_rgba(33,181,70,0.35)]"
          aria-hidden
        >
          <CheckOutlined style={{ fontSize: 26, fontWeight: 700 }} />
        </span>
        <h2 className="mt-4 text-lg font-semibold text-gray-900">Order placed successfully</h2>
        <p className="mt-2 max-w-sm text-sm leading-relaxed text-gray-500">
          {investorName ? (
            <>
              The sell order for <span className="font-medium text-gray-700">{investorName}</span>{' '}
              has been created. What would you like to do next?
            </>
          ) : (
            'The sell order has been created. What would you like to do next?'
          )}
        </p>
      </div>

      <div className={`mt-6 flex gap-2.5 ${isAboveSm ? 'flex-row' : 'flex-col-reverse'}`}>
        <Button
          block={!isAboveSm}
          onClick={onGoToTransactions}
          className={`${BTN_BASE} ${isAboveSm ? 'flex-1' : ''}`}
          type="primary"
        >
          Go to transactions
        </Button>
        <Button
          block={!isAboveSm}
          onClick={onCreateNewOrder}
          className={`${BTN_OUTLINE} ${isAboveSm ? 'flex-1' : ''}`}
        >
          Create new order
        </Button>
      </div>
    </Modal>
  );
}
